import React from 'react';
import { 
    Show, 
    SimpleShowLayout, 
    TextField,
    DateField,
    EmailField,
    BooleanField,
    NumberField,
    usePermissions
} from 'react-admin';
import { Typography, Box } from '@mui/material';
import { processPermissions } from "../../common/roleUtils";

const SectionTitle = ({ children }) => (
    <Box sx={{ mt: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom color="primary">
            {children}
        </Typography>
    </Box>
);

export const StudentShow = props => {
    const { permissions } = usePermissions();
    let propsObj = { ...props };
    
    if (permissions) {
        // Use utility function to process permissions with role-based restrictions
        const processedPermissions = processPermissions(permissions, props.resource);
        propsObj = { ...propsObj, ...processedPermissions };
    }
    
    return (
        <React.Fragment>
            <Show label="Student Details" {...propsObj}>
                <SimpleShowLayout>
                    {/* Personal Information */}
                    <SectionTitle>Personal Information</SectionTitle>
                    
                    <TextField source="first_name" label="First Name" />
                    <TextField source="middle_name" label="Middle Name" />
                    <TextField source="last_name" label="Last Name" />
                    <DateField source="date_of_birth" label="Date of Birth" />
                    <TextField source="gender" label="Gender" />
                    <TextField source="blood_group" label="Blood Group" />
                    
                    {/* Contact Information */}
                    <SectionTitle>Contact Information</SectionTitle>
                    
                    <TextField source="mobile_number" label="Mobile Number" />
                    <EmailField source="email" label="Email" />
                    <TextField source="address" label="Address" />
                    <TextField source="city" label="City" />
                    <TextField source="state" label="State" />
                    <TextField source="pincode" label="Pincode" />
                    <TextField source="aadhar_number" label="Aadhar Number" />
                    
                    {/* Father Information */}
                    <SectionTitle>Father Information</SectionTitle>
                    
                    <TextField source="father_name" label="Father Name" />
                    <TextField source="father_mobile" label="Father Mobile" />
                    <TextField source="father_occupation" label="Father Occupation" />
                    
                    {/* Mother Information */}
                    <SectionTitle>Mother Information</SectionTitle>
                    
                    <TextField source="mother_name" label="Mother Name" />
                    <TextField source="mother_mobile" label="Mother Mobile" />
                    <TextField source="mother_occupation" label="Mother Occupation" />
                    
                    {/* Guardian Information */}
                    <SectionTitle>Guardian Information</SectionTitle>
                    
                    <TextField source="guardian_name" label="Guardian Name" />
                    <TextField source="guardian_mobile" label="Guardian Mobile" />
                    <TextField source="guardian_relation" label="Guardian Relation" />
                    <TextField source="emergency_contact" label="Emergency Contact" />
                    
                    {/* Academic History */}
                    <SectionTitle>Previous Academic Information</SectionTitle>
                    
                    <TextField source="previous_school" label="Previous School" />
                    <TextField source="previous_class" label="Previous Class" />
                    <NumberField source="previous_percentage" label="Previous Percentage" options={{ minimumFractionDigits: 2 }} />
                    
                    {/* Additional Information */}
                    <SectionTitle>Additional Information</SectionTitle>
                    
                    <TextField source="photo_url" label="Photo URL" />
                    <TextField source="remarks" label="Remarks" />
                    <BooleanField source="is_active" label="Active" />
                    
                    {/* System Information */}
                    <SectionTitle>System Information</SectionTitle>
                    
                    <TextField source="id" label="Student ID" />
                    <DateField source="created_at" label="Created At" showTime />
                    <DateField source="updated_at" label="Updated At" showTime />
                </SimpleShowLayout>
            </Show>
        </React.Fragment>
    );
}
